// Vee Validate
// Simple Vue.js input validation plugin https://baianat.github.io/vee-validate/
// https://github.com/baianat/vee-validate
import VeeValidate from 'vee-validate'

// Custom Validators
import VeeValidateCpfValidator from './validators/cpf'
import VeeValidateCnpjValidator from './validators/cnpj'
import VeeValidateCpfCnpjValidator from './validators/cpfCnpj'
import VeeValidateCelValidator from './validators/cel'
import VeeValidateTelValidator from './validators/tel'
import VeeValidateTelCelValidator from './validators/telCel'
import VeeValidateFileMinValidator from './validators/fileMin'
import VeeValidateFileMaxValidator from './validators/fileMax'
import VeeValidateMinLengthValidator from './validators/minLength'
import VeeValidateMaxLengthValidator from './validators/maxLength'
import VeeValidateMinValidator from './validators/min'
import VeeValidateMaxValidator from './validators/max'
import VeeValidateConditionalValidator from './validators/conditional'

const plugin = {
  install: Vue => {
    Vue.use(VeeValidate, {
      errorBagName: 'errors', // change if property conflicts
      events: 'blur',
      fieldsBagName: 'fieldsVeeValidate',
      locale: 'pt_BR'
    })

    // Add custom rules
    VeeValidate.Validator.extend('cpf', VeeValidateCpfValidator)
    VeeValidate.Validator.extend('cnpj', VeeValidateCnpjValidator)
    VeeValidate.Validator.extend('cpfCnpj', VeeValidateCpfCnpjValidator)
    VeeValidate.Validator.extend('cel', VeeValidateCelValidator)
    VeeValidate.Validator.extend('tel', VeeValidateTelValidator)
    VeeValidate.Validator.extend('telCel', VeeValidateTelCelValidator)
    VeeValidate.Validator.extend('fileMin', VeeValidateFileMinValidator)
    VeeValidate.Validator.extend('fileMax', VeeValidateFileMaxValidator)
    VeeValidate.Validator.extend('minLength', VeeValidateMinLengthValidator)
    VeeValidate.Validator.extend('maxLength', VeeValidateMaxLengthValidator)
    VeeValidate.Validator.extend('min', VeeValidateMinValidator)
    VeeValidate.Validator.extend('max', VeeValidateMaxValidator)
    VeeValidate.Validator.extend('conditional', VeeValidateConditionalValidator)
  }
}

export default plugin
